import { useMemo } from "react";
import { catcat as cc } from "cerulean";
import styles from "./MerchantIcon.module.scss";

export interface MerchantIconProps {
  name: string;
  imageUrl?: string;
  size?: "s" | "l";
}

const MerchantIcon = ({ name, imageUrl, size = "l" }: MerchantIconProps) => {
  const initials = useMemo(() => name.slice(0, 2).toUpperCase(), [name]);
  const containerClassName = useMemo(
    () =>
      cc(styles.container, {
        [styles.small]: size === "s",
        [styles.placeholder]: !imageUrl,
      }),
    [size]
  );

  if (imageUrl) {
    return (
      <div className={containerClassName}>
        <img src={imageUrl} alt={name} className={styles.image} />
      </div>
    );
  }

  return (
    <div className={containerClassName}>
      <span className={styles.initials}>{initials}</span>
    </div>
  );
};

export default MerchantIcon;
